import { Component, Input } from '@angular/core';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
})
export class ProgressBarComponent {
  //width: string = '50%'
  @Input('width') width: string;
}
